import "@/index.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BottomNav from "@/components/BottomNav";
import LoginPage from "@/pages/LoginPage";
import RequestAccessPage from "@/pages/RequestAccessPage";
import AdminPage from "@/pages/AdminPage";
import DashboardPage from "@/pages/DashboardPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectNewPage from "@/pages/ProjectNewPage";
import ProjectReviewPage from "@/pages/ProjectReviewPage";
import ProjectMaterialsConfirmPage from "@/pages/ProjectMaterialsConfirmPage";
import FinalMaterialsReviewPage from "@/pages/FinalMaterialsReviewPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import ProjectShopPage from "@/pages/ProjectShopPage";
import ShopPage from "@/pages/ShopPage";
import HouseholdPage from "@/pages/HouseholdPage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import TermsPage from "@/pages/TermsPage";
import FeedbackPage from "@/pages/FeedbackPage";
import CodeRedeemPage from "@/pages/CodeRedeemPage";
import TermsGate from "@/components/TermsGate";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-8 text-timber-700">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/code" element={<CodeRedeemPage />} />
        <Route path="/request-access" element={<RequestAccessPage />} />
        <Route path="/invite/:code" element={<AcceptInvitePage />} />
        <Route path="/terms" element={<TermsPage />} />

        <Route path="/" element={<RequireAuth><><TermsGate /><DashboardPage /></></RequireAuth>} />
        <Route path="/projects" element={<RequireAuth><ProjectsPage /></RequireAuth>} />
        <Route path="/projects/new" element={<RequireAuth><ProjectNewPage /></RequireAuth>} />
        <Route path="/projects/new/review" element={<RequireAuth><ProjectReviewPage /></RequireAuth>} />
        <Route path="/projects/new/materials" element={<RequireAuth><ProjectMaterialsConfirmPage /></RequireAuth>} />
        <Route path="/projects/new/final-review" element={<RequireAuth><FinalMaterialsReviewPage /></RequireAuth>} />
        <Route path="/projects/:id" element={<RequireAuth><ProjectDetailPage /></RequireAuth>} />
        <Route path="/projects/:id/shop" element={<RequireAuth><ProjectShopPage /></RequireAuth>} />
        <Route path="/shop" element={<RequireAuth><ShopPage /></RequireAuth>} />
        <Route path="/household" element={<RequireAuth><HouseholdPage /></RequireAuth>} />
        <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
        <Route path="/feedback" element={<RequireAuth><FeedbackPage /></RequireAuth>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-kraft">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#FAFAF9",
                border: "2px solid #D5CEC4",
                color: "#3A2E2A",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 600,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
